const STORAGE_KEY = 'ipe-workbench-notifications-read';

function readStore() {
  if (typeof window === 'undefined') {
    return { personal: {}, system: {} };
  }
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return { personal: {}, system: {} };
    const parsed = JSON.parse(raw);
    return {
      personal: parsed?.personal && typeof parsed.personal === 'object' ? parsed.personal : {},
      system: parsed?.system && typeof parsed.system === 'object' ? parsed.system : {},
    };
  } catch {
    return { personal: {}, system: {} };
  }
}

function writeStore(store) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch {
    // ignore quota errors
  }
}

export function getReadNotificationIds(channel) {
  const store = readStore();
  return store[channel] || {};
}

export function isNotificationRead(channel, id) {
  if (!id) return false;
  return Boolean(getReadNotificationIds(channel)[id]);
}

export function markNotificationRead(channel, id) {
  if (!id) return;
  const store = readStore();
  store[channel] = { ...store[channel], [id]: Date.now() };
  writeStore(store);
}

export function markNotificationsRead(channel, ids) {
  if (!Array.isArray(ids) || ids.length === 0) return;
  const store = readStore();
  const next = { ...store[channel] };
  const now = Date.now();
  ids.forEach((id) => {
    if (id) next[id] = now;
  });
  store[channel] = next;
  writeStore(store);
}

export function countUnreadNotifications(channel, notifications) {
  if (!Array.isArray(notifications) || notifications.length === 0) return 0;
  const readMap = getReadNotificationIds(channel);
  return notifications.filter((item) => item?.id && !readMap[item.id]).length;
}
